import type { BikeParkMetadata } from "~/lib/api";

export const ACCESS_LABELS: Record<keyof BikeParkMetadata, string> = {
  liftAccess: "Lift access",
  shuttleAccess: "Shuttle access",
};
